import enviro from 'enviro';
import { COOKIE_ECHO_USER, FEATURES_DEFAULTS, PRODUCT, PUBLIC_META, PURCHASE_MOTIONS } from 'pricing-pages-lib/constants/EarlyRequesterNames';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/languageUtils';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
import quickFetch from 'quick-fetch';
import { getBooleanFromString, getLocalStorageItem, getQueryParam, getUtk } from './earlyRequesterUtils';
(function () {
  const isQAProxy = getIsQAProxy();
  const IS_QA = window.location.hostname.indexOf('hubspotqa') !== -1 || isQAProxy;
  const HUBLET_SUFFIX = enviro.getHublet() === 'na1' ? '' : `-${enviro.getHublet()}`;
  const APP_DOMAIN = IS_QA ? `app${HUBLET_SUFFIX}.hubspotqa.com` : `app${HUBLET_SUFFIX}.hubspot.com`;
  window.__HUBSPOT_UTK = getUtk(); // global var so we can access in the app code

  // const UTK_OR_UUID = getStashedUuid() || UTK || generateUuid(); // will exist & be persisted for everyone

  const forceSeatsParam = getQueryParam('forceSeatsPricing');
  const forceSeatsLocalStorage = getLocalStorageItem('SEATS_VERSIONS_FEATURE_FLAG_OVERRIDE');
  const isUngatedForSeats = getBooleanFromString(forceSeatsLocalStorage || '') || getBooleanFromString(forceSeatsParam || '');
  const countryCodeParam = isUngatedForSeats ? '&countryCode=AU' : window.COUNTRY_CODE_FROM_LOCALE ? `&countryCode=${window.COUNTRY_CODE_FROM_LOCALE.toUpperCase()}` : '';
  const cookieUrl = isQAProxy ? 'https://api.hubspotqa.com/cookie-echo/v1/user' : quickFetch.getApiUrl('/cookie-echo/v1/user', false);
  // Redirect detection
  quickFetch.makeEarlyRequest(COOKIE_ECHO_USER, {
    url: cookieUrl,
    type: 'GET',
    dataType: 'json',
    // Relatively quick timeout since missing the redirect is not a big deal, and we don't want to block pageload long
    // This might mean that redirects skew towards NorthAm and those with fast internet connections
    timeout: 2000,
    whenFinished(response) {
      // This endpoint will 401 if you're not logged in so wont hit this block
      const email = response.email;

      // by default we redirect hubspot users. We can override that by having hsRedirect=true in query param
      const hsRedirect = getQueryParam('hsRedirect');
      const shouldRedirectHubSpotUsers = getBooleanFromString(hsRedirect || '');
      if (email.indexOf('@hubspot.com') > -1 && !shouldRedirectHubSpotUsers) {
        // Don't redirect hubspot users. Important for sales
        // who want a consistent demo experience on hubspot.com
        return;
      }

      // get path after /pricing
      const newPath = window.location.pathname.split('/').slice(2).join('/');
      /**
       * Most query params are NOT preserved through short links.
       * Should be fine as most people are just going to the base /pricing/X pages
       * If we want to preserve query params we'll need to explicitly whitelist the query params, which can be done in this config:
       * https://private.hubteam.com/config/com.hubspot.shortlinks.service/ShortlinksConfig/ALLOWED_QUERY_PARAMS/STRING_SET
       * ShortLinks docs: https://product.hubteam.com/docs/appsystems/shortlinks.html
       */
      const redirectUrl = `https://${APP_DOMAIN}/l/pricing/${newPath}${window.location.search}`;
      // Use redirect so we dont keep the public page in history
      window.location.replace(redirectUrl);
    }
  });

  // We include hostname b/c this request is cached. If we switch langs, we'll get a mismatched 'Access-Control-Allow-Origin'
  // which will cause an error, so we want to make sure switching domains doesn't read from the cache

  const productUrl = isQAProxy ? ` https://api.hubspotqa.com/monetization/v3/product?host=${window.location.hostname}${countryCodeParam}` : quickFetch.getApiUrl(`/monetization/v3/product?host=${window.location.hostname}${countryCodeParam}`, false);
  quickFetch.makeEarlyRequest(PRODUCT, {
    url: productUrl,
    type: 'GET',
    dataType: 'json',
    withCredentials: true,
    timeout: 12000
  });
  const preferredLanguage = getPreferredLanguage();
  let purchaseMotionUrl = isQAProxy ? 'https://api.hubspotqa.com/monetization/v3/purchase-motions/public-pricing' : quickFetch.getApiUrl('/monetization/v3/purchase-motions/public-pricing', false);
  purchaseMotionUrl = `${purchaseMotionUrl}/${preferredLanguage.toLowerCase()}?location=MERCH_CARD&location=CALCULATOR${countryCodeParam}`;
  if (preferredLanguage && preferredLanguage.length) {
    quickFetch.makeEarlyRequest(PURCHASE_MOTIONS, {
      url: purchaseMotionUrl,
      type: 'GET',
      dataType: 'json',
      withCredentials: true,
      timeout: 12000
    });
  }
  let publicMetaUrl = isQAProxy ? 'https://api.hubspotqa.com/monetization/v3/public-pricing' : quickFetch.getApiUrl('/monetization/v3/public-pricing', false);
  publicMetaUrl = `${publicMetaUrl}/${preferredLanguage.toLowerCase()}`;
  const isInIndia = window.location.host.indexOf('hubspot.in') > -1;

  // the (window as any).COUNTRY_CODE_FROM_LOCALE should be set BEFORE the early requester script is loaded in the base jade file
  const preferredCountry = isUngatedForSeats ? 'AU' : isInIndia ? 'in' : window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  if (preferredCountry) {
    publicMetaUrl = `${publicMetaUrl}?preferredCountry=${preferredCountry}`;
  }
  quickFetch.makeEarlyRequest(PUBLIC_META, {
    url: publicMetaUrl,
    type: 'GET',
    dataType: 'json',
    withCredentials: true,
    timeout: 12000
  });
  const i18nLangLocale = window.I18N_MANUAL_LANG || preferredLanguage.toLowerCase() || 'en-us';
  let featuresDefaultsUrl = isQAProxy ? 'https://api.hubspotqa.com/feature/store/v1/features/defaults' : quickFetch.getApiUrl('/feature/store/v1/features/defaults', false);
  featuresDefaultsUrl += `/${i18nLangLocale}`;
  quickFetch.makeEarlyRequest(FEATURES_DEFAULTS, {
    url: featuresDefaultsUrl,
    type: 'GET',
    dataType: 'json',
    timeout: 12000,
    withCredentials: true
  });
})();